import { SpoNatureFullResponseSettingsItem } from '@spo/types';
import { useTranslation } from 'react-i18next';

const DisplaySegmentations = ({
  settings,
}: {
  settings: SpoNatureFullResponseSettingsItem[];
}) => {
  const { t } = useTranslation();

  const latestSettingsFilled = settings
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0]
    .usageSegmentationTypes.filter((seg) => !!seg.label);

  if (latestSettingsFilled.length) {
    return <div>{latestSettingsFilled.map((seg) => seg.label).join(', ')}</div>;
  } else {
    return (
      <div className="no-usage-segmentation">
        {t('architecture.drawer.settings.no-usage-seg-type')}
      </div>
    );
  }
};

export default DisplaySegmentations;
